module.exports = __webpack_public_path__ + "static/media/loading.b5c8b5e1.gif";